import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { newItem, withKey } from "@/pages/admin/QuoteItems";

export const EMPTY_QUOTE = { lead_id: null, customer_name: "", customer_phone: "", customer_email: "", customer_address: "", kwp: "", vat_rate: 10, notes: "", status: "Bozza", items: [] };

const itemsFromLead = (l) => [
  { description: `Moduli fotovoltaici 400 W (${l.kwp} kWp)`, qty: l.panels, unit_price: 0 },
  { description: "Inverter", qty: 1, unit_price: 0 },
  { description: "Strutture di montaggio e quadri elettrici", qty: 1, unit_price: 0 },
  { description: "Installazione, collaudo e pratiche GSE", qty: 1, unit_price: 0 },
].map(withKey);

const fromLead = (l) => ({ ...EMPTY_QUOTE, lead_id: l.id, customer_name: l.name, customer_phone: l.phone, customer_email: l.email || "",
  customer_address: l.address, kwp: l.kwp, vat_rate: l.building_type === "Villa Unifamiliare" ? 10 : 22, items: itemsFromLead(l) });

const withKeys = (q) => ({ ...q, items: q.items.map(withKey) });

// Calcolo totali del preventivo (stessa logica del server)
export function quoteTotals(q) {
  const subtotal = q.items.reduce((s, i) => s + Number(i.qty || 0) * Number(i.unit_price || 0), 0);
  const vat = (subtotal * q.vat_rate) / 100;
  return { subtotal, vat, total: subtotal + vat };
}

export const quotePayload = (q) => ({ ...q, kwp: q.kwp === "" || q.kwp == null ? null : Number(q.kwp), vat_rate: Number(q.vat_rate),
  items: q.items.map(({ _key, ...i }) => ({ ...i, qty: Number(i.qty || 0), unit_price: Number(i.unit_price || 0) })) });

// Caricamento (nuovo, da lead o esistente) e salvataggio del preventivo
export function useQuoteForm(id, leadId) {
  const api = useApi();
  const navigate = useNavigate();
  const [q, setQ] = useState(id || leadId ? null : { ...EMPTY_QUOTE, items: [newItem()] });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) api("get", `/admin/quotes/${id}`).then((data) => setQ(withKeys(data)));
    else if (leadId) api("get", `/admin/leads/${leadId}`).then((l) => setQ(fromLead(l)));
  }, [api, id, leadId]);

  const save = async () => {
    setSaving(true);
    try {
      const saved = await api(id ? "put" : "post", id ? `/admin/quotes/${id}` : "/admin/quotes", quotePayload(q));
      toast.success(`Preventivo ${saved.number} salvato`);
      setQ(withKeys(saved));
      if (!id) navigate(`/admin/preventivi/${saved.id}`, { replace: true });
    } catch (e) {
      toast.error(errMsg(e));
    }
    setSaving(false);
  };

  return { q, setQ, saving, save };
}
